import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const downloadCV = () => {
    const link = document.createElement('a');
    link.href = '/caleydames_CV.pdf';
    link.download = 'caleydames_CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-nav">
            <button 
              className="footer-link"
              onClick={() => scrollToSection('hero')}
            >
              About
            </button>
            <button 
              className="footer-link"
              onClick={() => scrollToSection('work')}
            >
              Work
            </button>
            <button 
              className="footer-link"
              onClick={() => scrollToSection('contact')}
            >
              Contact
            </button>
          </div>
          
          <button 
            className="footer-cv-btn shiny-btn"
            onClick={downloadCV}
          >
            <span className="btn-text">Download CV</span>
            <span className="btn-shine"></span>
          </button>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Caley Dames. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 